<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.view_branch") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #233076">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <form>
        <div class="row">
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.name_ar"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.name_en"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.addressAr')"
            v-model.trim="data.address_ar"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.addressEn')"
            v-model.trim="data.address_en"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model.trim="data.phone"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.time')"
            v-model.trim="data.time"
            disabled
          />
          <base-input
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.link_google_map')"
            v-model.trim="data.link_google_map"
            disabled
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShowBranch",

  data() {
    return {
      data: {
        name_ar: null,
        name_en: null,
        address_ar: null,
        address_en: null,
        phone: null,
        time: null,
        link_google_map: null,
      },
    };
  },

  methods: {
    async getData() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: `branches/${this.$route.params.id}`,
        });
        const item = res.data?.data?.Branch || {};
        this.data.name_ar = item.name_ar;
        this.data.name_en = item.name_en;
        this.data.address_ar = item.address_ar;
        this.data.address_en = item.address_en;
        this.data.phone = item.phone;
        this.data.time = item.time;
        this.data.link_google_map = item.link_google_map;
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message || "Failed to load branch details"
        );
      }
    },
  },

  created() {
    this.getData();
  },
};
</script>
